import { useMemo } from 'react';
import { IconRight, IconUpload, PermissionEnum, Table } from '@ui/src';
import { useAppSelector } from '@store';
import { OngoingMonitoringTableTypes } from '../types';
import Card from '../../../../components/common/card/card';
import { ongoingColumns, ongoingColumnsLabels } from '../variables/ongoing';
import formatOngoingMonitroing from '../helpers/format-ongoing-monitoring';
import { OrganizationType, OngoingMonitring } from '../../types';

import cn from '../styles.module.css';

const OngoingMonitoringTable = ({
  activePermissions,
  setShowOngoing,
  setExportPdfPanelVisible,
  ongoingIsLoading,
  ongoingIsFetching,
  onOngoingRowClick,
  type,
}: OngoingMonitoringTableTypes) => {
  const { ongoingMonitoring, ongoingMonitoringErrorsList } = useAppSelector(
    (state) => state.customerAml,
  );

  const formattedData = useMemo(() => {
    const data = formatOngoingMonitroing(
      ongoingMonitoring as OngoingMonitring[],
    );

    return data;
  }, [ongoingMonitoring]);

  return (
    <Card
      titleContent={
        <div className={cn.ongoingTitleWrapper}>
          <div className={cn.ongoingTitleLeft}>
            <div className={cn.ongoingTitle}>Ongoing monitoring</div>
            <button
              type="button"
              className={cn.ongoingShowMore}
              onClick={() => setShowOngoing(true)}
            >
              Show more
              <IconRight />
            </button>
          </div>

          <div className={cn.ongoingTitleRight}>
            {((type === OrganizationType.INDIVIDUAL &&
              activePermissions?.includes(
                PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_EXPORT_ACTION,
              )) ||
              (type === OrganizationType.CORPORATE &&
                activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_AML_EXPORT_ACTION,
                ))) && (
              <button
                type="button"
                className={cn.ongoingExport}
                onClick={() => setExportPdfPanelVisible(true)}
              >
                <IconUpload />
                Export PDF
              </button>
            )}
          </div>
        </div>
      }
    >
      <div
        className={`${cn.ongoingTableWrapper} ${
          ongoingIsLoading || ongoingIsFetching ? cn.isLoading : ''
        }`}
      >
        <Table
          columns={ongoingColumns}
          data={formattedData || []}
          sort={{}}
          onSort={() => {}}
          filters={{}}
          tableBodyClassName={ongoingMonitoring?.length ? '' : cn.emptyOngoing}
          columnsLabels={ongoingColumnsLabels}
          onFilterChange={() => {}}
          onRowClick={onOngoingRowClick}
          isLoading={ongoingIsLoading || ongoingIsFetching}
          error={ongoingMonitoringErrorsList}
        />
      </div>
    </Card>
  );
};

export default OngoingMonitoringTable;
